// This file is auto-generated by @hey-api/openapi-ts

/**
 * Offense state
 */
export const OffenseStateEnum = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    REJECTED: 'REJECTED'
} as const;

/**
 * Offense state
 */
export type OffenseStateEnum = typeof OffenseStateEnum[keyof typeof OffenseStateEnum];
